import { useEffect, useState } from 'react';
import { maskAadhaarNumber, maskPhoneNumber } from '../utils/maskingUtils';

const MaskedInput = ({ 
  type, 
  value, 
  onChange, 
  placeholder, 
  className,
  name,
  maxLength,
  disabled,
  required,
  ...otherProps 
}) => {
  const [displayValue, setDisplayValue] = useState('');
  const [actualValue, setActualValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const stringValue = String(value);
      setActualValue(stringValue);
      if (!isFocused) {
        const masked = type === 'phone' ? maskPhoneNumber(stringValue) : maskAadhaarNumber(stringValue);
        setDisplayValue(masked);
      } else {
        setDisplayValue(stringValue);
      }
    } else {
      setActualValue('');
      setDisplayValue('');
    }
  }, [value, type, isFocused]);

  const handleFocus = () => {
    setIsFocused(true);
    setDisplayValue(actualValue);
  };

  const handleBlur = () => {
    setIsFocused(false);
    const masked = type === 'phone' ? maskPhoneNumber(actualValue) : maskAadhaarNumber(actualValue);
    setDisplayValue(masked);
  };

  const handleChange = (e) => {
    let newValue = e.target.value;
    
    // Remove any asterisks that might be in the input
    newValue = newValue.replace(/\*/g, '');
    
    // For phone numbers, only allow digits and limit to 10
    if (type === 'phone') {
      newValue = newValue.replace(/\D/g, '');
      if (newValue.length > 10) newValue = newValue.slice(0, 10);
    }
    
    // For aadhaar numbers, only allow digits and limit to 12
    if (type === 'aadhaar') {
      newValue = newValue.replace(/\D/g, '');
      if (newValue.length > 12) newValue = newValue.slice(0, 12);
    }
    
    setActualValue(newValue);
    setDisplayValue(newValue);
    
    // Create a new event with the cleaned value
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        name: name || e.target.name,
        value: newValue
      }
    };
    
    if (onChange) {
      onChange(newEvent);
    }
  };

  return (
    <input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      className={className || 'form-control'}
      maxLength={maxLength}
      disabled={disabled}
      required={required}
    />
  );
};

export default MaskedInput;